<template>
  <div class="vm-card blockContentArea d-flex flex-column justify-content-center align-items-center"
       :class="isLongCard?'long-card':''">
    <p v-if="os"
       class="svg-icon">
      <inline-svg :src="`/media/svg/icons/General/${os}-desktop.svg`" />
    </p>
    <div class="faIcon"
         v-else-if="faIcon">
      <i :class="faIcon"></i>
    </div>
    <div class="firstLetterLogo"
         v-else-if="firstLetterLogo">
      {{ title.charAt(0).toUpperCase() }}
    </div>
    <p v-if="title"
       class="title text-center">{{title}} </p>
    <p v-if="subTitle"
       class="subTitle">{{subTitle}} </p>

    <slot> </slot>
  </div>
</template>

<script>
export default {
  name: 'VmInfoCard',
  props: {
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    os: {
      type: String,
    },
    firstLetterLogo: {
      type: Boolean,
      default: true,
    },
    faIcon: {
      type: String,
    },
    isLongCard: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.vm-card {
  width: 258px;
  min-width: 200px;
  min-height: 250px;
  height: 100%;
  padding: 30px 50px;
  border-top-left-radius: 12px;
  // border-bottom-left-radius: 12px;
  background: #0a1f44;
  &.long-card {
    min-height: 380px;
  }
  .svg-icon svg {
    height: 65px;
    width: 73px;
    margin-bottom: 10px;
  }
  .firstLetterLogo {
    font-size: 72px;
    line-height: 100%;
    color: #fff;
    border: 1px solid #b5b5c3;
    padding: 26px;
    margin-bottom: 20px;
    border-radius: 6px;
  }
  .faIcon {
    i {
      font-size: 38px;
      line-height: 21px;
      color: #ffffff;
      margin-bottom: 25px;
    }
  }
  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: #ffffff;
    margin-bottom: 0px;
  }
  .subTitle {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 21px;
    color: #b5b5c3;
    margin-bottom: 10px;
  }
}
</style> 